import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { HeaderCard } from '../../../event/components/HeaderCard';
import { Layout } from '../../../navigation/components/Layout/Layout';
import { BedroomOnlinePaymentCard } from './components/BedroomOnlinePaymentCard/BedroomOnlinePaymentCard';
import { BedroomUsersDrawer } from './components/BedroomUsersDrawer/BedroomUsersDrawer';
import { useBedrooms } from './useBedrooms';

interface BedroomsProps {
  isAdminView?: boolean;
}

export const Bedrooms: FunctionComponent<BedroomsProps> = ({
  isAdminView = false,
}) => {
  const {
    bedrooms,
    onJoinBedroom,
    onLeaveBedroom,
    joinedBedroomId,
    hasPaidBedroom,
    currentMilestone,
    currentEvent,
    onCloseBedroomUsersDrawer,
    selectedBedroom,
    canAccessBedrooms,
    canManageBedroomUsers,
    onOpenBedroomUsersDrawer,
  } = useBedrooms(isAdminView);

  return (
    <Layout
      title={isAdminView ? 'Administration - Chambres' : 'Ma Chambre'}
      activeTab={isAdminView ? 'adminBedrooms' : 'bedroom'}
    >
      <HeaderCard
        title={isAdminView ? 'Gérez les chambres' : 'Choisissez votre chambre'}
        description={
          isAdminView
            ? 'Consultez les chambres disponibles et ajustez les occupants si nécessaire.'
            : canAccessBedrooms
              ? 'Choisissez votre place, voyez les occupants déjà présents et changez de chambre si besoin.'
              : "Le choix de la chambre s'ouvre après l'achat d'une place en chambre."
        }
      />
      {canAccessBedrooms ? (
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {bedrooms.map((bedroom) => (
            <Card key={bedroom.id} sx={{ width: 500, mx: 2, mb: 4 }}>
              <CardContent>
                <Typography variant="h6">
                  Chambre {bedroom.doorNumber} - {bedroom.floor}
                  {bedroom.floor === 1 ? 'er' : 'e'} étage
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{ color: 'text.secondary' }}
                >
                  {bedroom.users.length}/{bedroom.maxUsers} personnes
                </Typography>
                {bedroom.users.map((user) => (
                  <Typography
                    key={user.id}
                  >{`- ${user.firstname} ${user.lastname}. ${user.nickname ? `- ${user.nickname}` : ''} - ${user.studyTown}`}</Typography>
                ))}
              </CardContent>
              {hasPaidBedroom &&
              joinedBedroomId === null &&
              bedroom.users.length < bedroom.maxUsers ? (
                <CardActions>
                  <Button
                    size="small"
                    onClick={() => onJoinBedroom(bedroom.id)}
                  >
                    Rejoindre cette chambre
                  </Button>
                </CardActions>
              ) : null}
              {hasPaidBedroom && joinedBedroomId === bedroom.id ? (
                <CardActions>
                  <Button
                    size="small"
                    color="error"
                    onClick={() => onLeaveBedroom(bedroom.id)}
                  >
                    Quitter cette chambre
                  </Button>
                </CardActions>
              ) : null}
              {canManageBedroomUsers ? (
                <CardActions>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => onOpenBedroomUsersDrawer(bedroom.id)}
                  >
                    Modifier les occupants
                  </Button>
                </CardActions>
              ) : null}
            </Card>
          ))}
        </Box>
      ) : (
        <Box>
          {currentEvent?.areBedroomFull ? (
            <Card>
              <CardContent>
                <Typography variant="h6">{`Place en chambre`}</Typography>
                <Typography>{`Il n'y a plus de place en chambre pour cet événement.`}</Typography>
              </CardContent>
            </Card>
          ) : currentEvent && currentMilestone?.bedroomValue ? (
            <BedroomOnlinePaymentCard
              bedroomValue={currentMilestone.bedroomValue}
              eventId={currentEvent.id}
            />
          ) : null}
        </Box>
      )}
      {currentEvent && selectedBedroom ? (
        <BedroomUsersDrawer
          bedroom={selectedBedroom}
          eventId={currentEvent.id}
          isOpen
          onClose={onCloseBedroomUsersDrawer}
        />
      ) : null}
    </Layout>
  );
};
